import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';

export default function useGetTimeoffByUserId(userId) {

    const { data, error, mutate, isLoading } = useSWR(`${apiBaseURL}/api/user/timeoffs?userId=${userId}`, {
        onSuccess: (data) => console.log('users timeoff fetched successfully:', data?.data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });
    const allPto = data?.data;
    const filterAprovedPto = data?.data?.filter(pto => pto.status !== 2) || [];
    const allAprovedPto = filterAprovedPto?.map((pto) => ({
                colorId: pto.status === 1 ? 2 : 3,
                allDay: pto.status === 1 ? false : true,
                text: pto.status === 1 ? pto?.comment || 'Approved time off' : 'Pending time off',
                startDate: pto?.ptoDates?.startDate,
                endDate: pto?.ptoDates?.endDate,
                comments: pto?.comments,
                status: pto?.status,
            })) || [];

    return {
        allPto,
        allAprovedPto,
        isLoading,
        error,
        mutate,
    };
}